import React from "react";
import PropTypes from 'prop-types'
import * as Yup from 'yup'
import {Row, Col, Modal} from 'antd'
import {Formik, FastField} from 'formik'
import typo from '../../../constants/dictionaries'

// Components
import Input from '../../Common/Input'
import Button from '../../Buttons'
import ValidatedText from "../../Common/ValidatedText";
import DisplayFormikState from "../../Table/DisplayFormikState";
import NumberField from "../../Common/NumberField";

const schema = Yup.object().shape({
  congSuatLapMay: Yup.number().required(),
  luuLuongKhaiThacMax: Yup.number().required(),
  luuLuongMaxQuaNMTD: Yup.number().required(),
});

const MiningQuantityModal = ({
                               isOpen = false,
                               initialValues,
                               handleOk,
                               handleCancel,
                               mode
                             }) => {
  return (
    <Modal
      visible={isOpen}
      title="Lưu lượng nước khai thác"
      footer={false}
      onCancel={handleCancel}
    >
      <Formik
        key={new Date()}
        enableReinitialize
        initialValues={initialValues}
        onSubmit={(value, actions) => {
          handleOk(value);
          actions.resetForm({});
        }}
        validationSchema={schema}
        render={({handleChange, handleSubmit, values, errors, touched, setFieldValue}) => (
          <form onSubmit={handleSubmit} autoComplete={false}>
            <Row>
              <FastField
                name="congSuatLapMay"
                render={({field}) => <NumberField
                  label={typo.cscore_quantity_capacity}
                  min={0}
                  id="congSuatLapMay"
                  {...field}
                  onChange={data => setFieldValue("congSuatLapMay", data)}/>}
              />
              {touched.congSuatLapMay && <ValidatedText type="danger">{errors.congSuatLapMay}</ValidatedText>}

              <FastField
                name="luuLuongKhaiThacMax"
                render={({field}) => <NumberField
                  label={typo.cscore_quantity_maximum_flowing}
                  min={0}
                  id="luuLuongKhaiThacMax" {...field}
                  onChange={data => setFieldValue("luuLuongKhaiThacMax", data)}/>}
              />
              {touched.luuLuongKhaiThacMax && <ValidatedText type="danger">{errors.luuLuongKhaiThacMax}</ValidatedText>}

              <FastField
                name="luuLuongMaxQuaNMTD"
                render={({field}) => <NumberField
                  label={typo.cscore_quantity_maximum_mining}
                  min={0}
                  id="luuLuongMaxQuaNMTD" {...field}
                  onChange={data => setFieldValue("luuLuongMaxQuaNMTD", data)}/>}
              />
              {touched.luuLuongMaxQuaNMTD && <ValidatedText type="danger">{errors.luuLuongMaxQuaNMTD}</ValidatedText>}
            </Row>
            <div className="mt-20"/>
            <Row type="flex" justify="end" align="middle">
              <Button type="outline" onClick={handleCancel}>{typo.cscore_cancel}</Button>
              <div className="ml-10"/>
              <Button type="submit" onClick={handleSubmit}>{typo.cscore_save}</Button>
            </Row>
            {/*<DisplayFormikState error={errors} value={values} touched={touched}/>*/}
          </form>
        )}/>
    </Modal>
  )
};

MiningQuantityModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  initialValues: PropTypes.object,
  handleOk: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  mode: PropTypes.string
};

export default MiningQuantityModal

